import CategoryPreviewSubCategoryList from './CategoryPreviewSubCategoryList';
import type { CategoryPreviewSubCategoryListProps } from './CategoryPreviewSubCategoryList';

export type { CategoryPreviewSubCategoryListProps };
export default CategoryPreviewSubCategoryList;
